import { createSlice } from "@reduxjs/toolkit";
import { updateTermsAndConditionsStatusAPI } from "../../services/updateTermsAndConditionsStatus";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  updatingId: null,
};

const updateTermsAndConditionsStatusSlice = createSlice({
  name: "updateTermsAndConditionsStatus",
  initialState,
  reducers: {
    updateTermsAndConditionsStatusInfo(state, action) {
      state.isLoading = true;
      state.updatingId = action?.payload?.termsConditionId ?? null;
      state.error = "";
      state.message = "";
    },
    updateTermsAndConditionsStatusInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "Status updated successfully";
      state.updatingId = null;
    },
    updateTermsAndConditionsStatusInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
      state.updatingId = null;
    },
    updateTermsAndConditionsStatusInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.updatingId = null;
    },
  },
});

export const updateTermsAndConditionsStatusHandler =
  (payload) => async (dispatch) => {
    try {
      dispatch(
        updateTermsAndConditionsStatusAction.updateTermsAndConditionsStatusInfo(
          payload,
        ),
      );
		const response = await updateTermsAndConditionsStatusAPI(payload);
		console.log("response", response);
      dispatch(
        updateTermsAndConditionsStatusAction.updateTermsAndConditionsStatusInfoSuccess(
          response,
        ),
      );
    } catch (e) {
      dispatch(
        updateTermsAndConditionsStatusAction.updateTermsAndConditionsStatusInfoFailure(
          e?.response?.data?.message || e?.message || String(e),
        ),
      );
    }
  };

export default updateTermsAndConditionsStatusSlice.reducer;
export const updateTermsAndConditionsStatusAction =
  updateTermsAndConditionsStatusSlice.actions;

